import { render, staticRenderFns } from "./WhatWeProvide.vue?vue&type=template&id=4340e837&"
import script from "./WhatWeProvide.vue?vue&type=script&lang=js&"
export * from "./WhatWeProvide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports